import { TableCell } from '@/components/ui/table';
import type { UnitOverviewRow } from '@/warranty-v3/entities/overview';

type FrontendIdCellProps = {
  row: UnitOverviewRow;
};

export function FrontendIdCell({ row }: FrontendIdCellProps) {
  return (
    <TableCell wide justify="left">
      {row.frontendId ?? '-'}
    </TableCell>
  );
}
